import React from "react";
import "./education.css";

function Education() {
  return (
    <>
      <div className="educationWrapper">
        {" "}
        Education
        <div className="edCardCurrent">
          <span className="title">
            Master of Science in AI Engineering [May 2027]{" "}
          </span>
          <span>Quantic School of Business and Technology</span>
        </div>
      </div>
      <div className="educationWrapper">
        <div className="edcardSection">
          <div className="edCard">
            <span>Full Stack Development with MERN</span>
            <span className="title">MIT</span>
          </div>
          <div className="edCard">
            <span>EMT-B </span>
            <span className="title">Citrus College</span>
          </div>
          <div className="edCard">
            <span>Bachelor's of Science </span>
            <span className="title">Azusa Pacific University</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default Education;
